<script setup lang="ts">
import { useId } from "vue";

defineProps<{ title: string }>();

const titleId = useId();
</script>
<template>
  <section
    :aria-labelledby="titleId"
    class="tw-max-w-full tw-divide-y tw-rounded-lg tw-border tw-bg-white *:tw-overflow-x-auto [&>*:not(:first-child)]:tw-px-3 [&>*:not(:first-child)]:tw-py-2"
  >
    <h2 :id="titleId" class="tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-gray-900">{{ title }}</h2>
    <slot />
  </section>
</template>
